import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE } from '../api-base.token';
import { InspectionEmailSubscriptionResponse } from './inspection-email-subscription-response';
import { InspectionEmailSubscriptionsRequest } from './inspection-email-subscriptions-request';

const path = 'email-subscriptions';

@Injectable({
  providedIn: 'root',
})
export class InspectionEmailSubscriptionsHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  getAll(): Observable<InspectionEmailSubscriptionResponse[]> {
    const url = Location.joinWithSlash(this.apiBase, path);

    return this.httpClient.get<InspectionEmailSubscriptionResponse[]>(url);
  }

  post(
    request: InspectionEmailSubscriptionsRequest
  ): Observable<InspectionEmailSubscriptionResponse[]> {
    const url = Location.joinWithSlash(this.apiBase, path);

    return this.httpClient.post<InspectionEmailSubscriptionResponse[]>(
      url,
      request
    );
  }
}
